/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import { miscNames, miscIconMap } from '../../../../src/shared/misc';
import { mediaIconNames, mediaIconMap } from '../../../../src/shared/socialmediaicons';
import { storageNames, storageIconMap } from '../../../../src/shared/storage';
import Button from '../../../../modules/react/components/stateless/Button';
import IconStyleTab from './IconStyleTab';
import styles from './StockIcons.scss';

const OPTION_AMENITIES = 'amenities';
const OPTION_SOCIAL_MEDIA = 'social media';
const OPTION_FONT_AWESOME = 'font awesome';

export default class Editor extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string,
    onCancelEdit: PropTypes.func.isRequired,
    onFinishEdit: PropTypes.func.isRequired,
    href: PropTypes.string,
    align: PropTypes.string,
    target: PropTypes.string,
  };

  static defaultProps = {
    color: '',
    icon: '',
    target: '_self',
    href: '',
    align: '',
  };

  static contextType = CurrentPageContext;

  state = {
    icon: this.props.icon,
    align: this.props.align,
    href: this.props.href,
    color: this.props.color,
    target: this.props.target,
    currentOption: OPTION_AMENITIES,
    showColorField: false,
  }

  setTarget = (e) => {
    this.setState({ target: e.target.value });
  }

  handleSave = ({ primary, secondary, tertiary }) => {
    const { onFinishEdit } = this.props;
    let { color } = this.state;
    if (color === primary) {
      color = 'primary';
    } else if (color === secondary) {
      color = 'secondary';
    } else if (color === tertiary) {
      color = 'tertiary';
    }

    const payload = {
      ...this.state,
      color,
    };

    onFinishEdit(payload);
  };

  handleIconChange = icon => () => {
    this.setState({ icon });
  }

  handleHrefChange = ({ value }) => this.setState({ href: value });

  handleColorChange = ({ value }) => {
    if (value === 'custom') {
      this.setState({ showColorField: true });
    } else {
      this.setState({ color: value });
    }
  }

  handleAlignChange = ({ value }) => {
    this.setState({ align: value });
  }

  render() {
    const { onCancelEdit } = this.props;
    const {
      icon, align, target, href, currentOption, showColorField, color,
    } = this.state;

    const { primaryColor, secondaryColor, tertiaryColor } = this.context;

    const themeColors = {
      primary: primaryColor,
      secondary: secondaryColor,
      tertiary: tertiaryColor,
    };

    const iconColor = (() => {
      switch (color) {
        case 'primary':
          return primaryColor;
        case 'secondary':
          return secondaryColor;
        case 'tertiary':
          return tertiaryColor;
        default:
          return color || secondaryColor;
      }
    })();

    return (
      <Modal
        show
        onDismiss={onCancelEdit}
        aria-labelledby="stock-icons-editor"
      >
        <Modal.Header>
          <Modal.Title>Icon Options</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.root}>
          <Tabs id="stockicons-edit-modal-tab" defaultActiveKey={1}>
            <Tab title="Icon" eventKey={1}>
              <div style={{ fontWeight: 'bold' }}>
                Choose one of the stock options.
              </div>
              <Row className={styles.stockOptions}>
                <Col xs={4}>
                  <span
                    className={`${icon} ${styles.iconPreview}`}
                    style={{ color: iconColor }}
                  />
                  <div className={styles.border}>Icon type</div>
                  <div
                    onClick={() => this.setState({ currentOption: OPTION_AMENITIES })}
                    className={`${styles.category}
                          ${currentOption === OPTION_AMENITIES ? styles.selectedCategory : ''}`}
                  >
                    Storage
                  </div>
                  <div
                    onClick={() => this.setState({ currentOption: OPTION_SOCIAL_MEDIA })}
                    className={`${styles.category} ${currentOption === OPTION_SOCIAL_MEDIA
                      ? styles.selectedCategory : ''}`}
                  >
                    Social Media
                  </div>
                  <div
                    onClick={() => this.setState({ currentOption: OPTION_FONT_AWESOME })}
                    className={`${styles.category} ${currentOption === OPTION_FONT_AWESOME
                      ? styles.selectedCategory : ''}`}
                  >
                    Miscellaneous
                  </div>
                </Col>
                {currentOption === OPTION_AMENITIES
                  ? (
                    <Col xs={8} className={styles.scrollable}>
                      {storageNames.map((storage, index) => (
                        <Col
                          xs={2}
                          key={`stock-icon-${index}`}
                          className={`${styles.icon} ${icon === storageIconMap[storage]
                            ? styles.selected : styles.nonSelected}`}
                        >
                          <span
                            className={storageIconMap[storage]}
                            onClick={this.handleIconChange(storageIconMap[storage])}
                          />
                        </Col>
                      ))
                    }
                    </Col>
                  ) : ''}
                {currentOption === OPTION_SOCIAL_MEDIA
                  ? (
                    <Col xs={8} className={styles.scrollable}>
                      {mediaIconNames.map((media, index) => (
                        <Col
                          xs={2}
                          key={`stock-icon-${index}`}
                          className={`${styles.icon} ${icon === mediaIconMap[media]
                            ? styles.selected : styles.nonSelected}`}
                        >
                          <span
                            className={mediaIconMap[media]}
                            onClick={this.handleIconChange(mediaIconMap[media])}
                          />
                        </Col>
                      ))
                    }
                    </Col>
                  ) : ''}
                {currentOption === OPTION_FONT_AWESOME
                  ? (
                    <Col xs={8} className={styles.scrollable}>
                      {miscNames.map((misc, index) => (
                        <Col
                          xs={2}
                          key={`stock-icon-${index}`}
                          className={`${styles.icon} ${icon === miscIconMap[misc]
                            ? styles.selected : styles.nonSelected}`}
                        >
                          <span
                            className={miscIconMap[misc]}
                            onClick={this.handleIconChange(miscIconMap[misc])}
                          />
                        </Col>
                      ))
                    }
                    </Col>
                  ) : ''}
              </Row>
            </Tab>
            <Tab title="Styling" eventKey={2}>
              <IconStyleTab
                icon={icon}
                align={align}
                color={iconColor}
                colors={themeColors}
                href={href}
                showColorField={showColorField}
                target={target}
                setTarget={this.setTarget}
                handleColorChange={this.handleColorChange}
                handleHrefChange={this.handleHrefChange}
                handleAlignChange={this.handleAlignChange}
              />
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={onCancelEdit}>Cancel</Button>
          <Button
            onClick={() => this.handleSave(themeColors)}
            type="submit"
            variant="success"
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
